export const GatewayRetryMapping = {
  'us': [
    process.env.bluesnapUSChargebeeGatewayId,
    process.env.epdUSGatewayId,
  ],
};

export default GatewayRetryMapping;
